import React from 'react';
import styles from './RadioList.module.scss';
import { joinClasses } from '../../../../../../Utils/className.util';
import Text from '../../../Text';

export interface RadioListProps {
	options: RadioListItem[];
	value?: string | number | boolean;
	onChange?: (value: string | number | boolean) => void;
	inLine?: boolean;
}

export interface RadioListItem {
	title: string;
	value: string | number | boolean;
}

const RadioList: React.FC<RadioListProps> = React.forwardRef<
	HTMLDivElement,
	React.PropsWithChildren<RadioListProps>
>(({ value, options, onChange, inLine = false }, ref) => {
	const handleRadioItemClick = (item: RadioListItem) => {
		onChange?.(item.value);
	};

	return (
		<div
			className={joinClasses([styles.wrapper, inLine && styles.inLine])}
			ref={ref}
		>
			{options.map((item, index) => (
				<div
					key={index}
					className={styles.radioWrapper}
					onClick={() => {
						handleRadioItemClick(item);
					}}
				>
					<div
						className={joinClasses([
							styles.radio,
							value === item.value && styles.active,
						])}
					/>
					<div className={styles.wrapper2}>
						<Text className={styles.title} tx={item.title} inline firstUpper />
					</div>
				</div>
			))}
		</div>
	);
});

export default RadioList;
